import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { ADMIN_URL } from 'src/constants/global'
import type { Company } from 'src/types/global'

export const useCompanies = (): Company[] =>
  useFetch<Company[]>(ADMIN_URL + '/companies')
